import $ from "jquery";
import {onClick, isMobile} from './Helper';

const keys = {37: 1, 38: 1, 39: 1, 40: 1};

function preventDefault(e) {
    e.preventDefault();
}

function preventDefaultForScrollKeys(e) {
    if (keys[e.keyCode]) {
        preventDefault(e);
        return false;
    }
}

// modern Chrome requires { passive: false } when adding event
let supportsPassive = false;
try {
    window.addEventListener("test", null, Object.defineProperty({}, 'passive', {
        get: function () { supportsPassive = true; }
    }));
} catch(e) {}

const wheelOpt = supportsPassive ? {passive: false} : false;
const wheelEvent = 'onwheel' in document.createElement('div') ? 'wheel' : 'mousewheel';

// call this to Disable
function disableScroll(elem) {
    elem.addEventListener('DOMMouseScroll', preventDefault, false); // older FF
    elem.addEventListener(wheelEvent, preventDefault, wheelOpt); // modern desktop
    elem.addEventListener('touchmove', preventDefault, wheelOpt); // mobile
    elem.addEventListener('keydown', preventDefaultForScrollKeys, false);
}


function Menu(options) {
    this.container = $(document.getElementById(options.container));
    this.openButton = $(document.getElementById(options.openButton));
    this.closeButton = $(document.getElementById(options.closeButton));

    this.tabs = options.tabs;

    this.init();
}

Menu.prototype.init = function () {
    let menu = this;

    menu.tabs.forEach(function (tab) {
        onClick('#'+tab, function () {
            menu.state(tab);
        });
    });

    onClick(menu.openButton, function () {
        if (menu.isOpen()) {
            menu.close();
        } else {
            menu.open();
        }
    });

    onClick(menu.closeButton, function () {
        menu.close();
    });
};

Menu.prototype.state = function (state) {
    this.tabs.forEach(function (tab) {
        if (tab === state) {
            $('#'+tab).addClass("active");
            $('.'+tab).addClass("active");
        } else {
            $('#'+tab).removeClass("active");
            $('.'+tab).removeClass("active");
        }
    });
};

Menu.prototype.open = function () {
    this.container.addClass("open");

    if (isMobile()) {
        this.hideInfobox();
    }
};

Menu.prototype.close = function () {
    this.container.removeClass("open");

    this.showInfobox();
};

Menu.prototype.hideInfobox = function () {
    window.scrollTo(0, 0);

    $("body").addClass("no-scroll");
    setTimeout(function() {
        $("#side-menu").addClass("no-scroll");
    }, 500);
};

Menu.prototype.showInfobox = function () {
    $("#side-menu").removeClass("no-scroll");
    setTimeout(function() {
        $("body").removeClass("no-scroll");
    }, 1000);
};

Menu.prototype.isOpen = function () {
    return this.container.hasClass("open");
};

export default Menu;
